(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function(){
    'use strict';
    var burger = document.querySelector('[data-tzh-burger]');
    var drawer = document.querySelector('[data-tzh-drawer]');
    var closes = document.querySelectorAll('[data-tzh-drawer-close]');
    var lastFocused = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function supportsInert(){ return 'inert' in HTMLElement.prototype; }

    function openDrawer(){
      if(!drawer) return;
      lastFocused = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.removeAttribute('aria-hidden');
      drawer.classList.add('is-open');
      if(burger) burger.setAttribute('aria-expanded','true');
      document.body.style.overflow='hidden';
      var target = drawer.querySelector('.tzh-drawer__close') || drawer.querySelector(FOCUSABLE);
      if(target) { window.requestAnimationFrame(function(){ target.focus(); }); }
    }

    function closeDrawer(){
      if(!drawer) return;
      if(drawer.contains(document.activeElement)){
        var back = lastFocused || burger;
        if(back && typeof back.focus === 'function') back.focus();
        else if(document.activeElement && document.activeElement.blur) document.activeElement.blur();
      }
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      drawer.setAttribute('inert','');
      if(burger) burger.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
    }

    if(burger) burger.addEventListener('click', openDrawer);
    Array.prototype.forEach.call(closes, function(el){ el.addEventListener('click', closeDrawer); });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ closeDrawer(); return; }
      if(e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
      var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function(el){
        return el.offsetParent !== null || el === document.activeElement;
      });
      if(!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });

    if(!supportsInert() && drawer){
      var syncTabindex = function(){
        var open = drawer.classList.contains('is-open');
        Array.prototype.forEach.call(drawer.querySelectorAll(FOCUSABLE), function(el){
          if(open) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex','-1');
        });
      };
      syncTabindex();
      if(window.MutationObserver){
        new MutationObserver(syncTabindex).observe(drawer, { attributes:true, attributeFilter:['class'] });
      }
    }

    function refreshCart(){
      try {
        fetch('/cart.js', { credentials:'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){
            if(!data) return;
            var count = (data.item_count != null) ? data.item_count : 0;
            document.querySelectorAll('[data-tzh-cart-count]').forEach(function(el){
              el.textContent = count;
              var badge = el.closest('.tzh-header__cart-badge');
              if(badge){
                if(count > 0) badge.classList.remove('is-empty');
                else badge.classList.add('is-empty');
              }
            });
          })
          .catch(function(){ /* silent */ });
      } catch(e) {}
    }
    refreshCart();
    document.addEventListener('cart:refresh', refreshCart);
    ['cart:updated','cart:item-added','cart:changed'].forEach(function(ev){ document.addEventListener(ev, refreshCart); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzh-bart-check"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('click', function(e) {
    var q = e.target.closest('.faq__q');
    if (q) q.parentElement.classList.toggle('is-open');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzh-berater"] && !Shopify.designMode) return;
  try {
    

  // Advisor-Modal-Trigger — wird funktional, sobald tzh-config.js + advisor.js geladen sind
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="open-advisor"]');
    if (!btn) return;
    e.preventDefault();
    if (window.Advisor && typeof window.Advisor.open === 'function') {
      window.Advisor.open();
    } else {
      // Fallback: scroll to questions section if Advisor JS not loaded
      var target = document.getElementById('advisor-start');
      if (target) target.scrollIntoView({behavior:'smooth'});
    }
  });


  } catch(e) { console.error(e); }
})();
})();
